// ─────────────────────────────────────────────────────────────────────────────
// SAP Insights — dev-only POC page.
//
// Duplicate of the Automation Insights page pattern, trimmed to just the
// Platform Table + assignment-group drill-down for 5 SAP platforms that have
// no automation yet. Own filter context (2-week default, vs. Automation
// Insights' 12-week default), own backend tables/endpoints — see
// SapFilterContext.tsx / sapInsightsService.ts / the backend's
// sap_tickets/sap_platform_summary tables for the full isolation story.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { SapFilterProvider } from '../contexts/SapFilterContext';
import SapFilterBar from './sap-insights/SapFilterBar';
import SapPlatformSummaryPanel from './sap-insights/SapPlatformSummaryPanel';

export default function SapInsights() {
  return (
    <SapFilterProvider>
      <Box sx={{ p: 3 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems={{ md: 'flex-end' }} gap={2} mb={3}>
          <Box>
            <Typography variant="h5" fontWeight={700} color="text.primary">
              SAP Insights
            </Typography>
            <Typography variant="body2" color="text.secondary">
              SAP platform ticket volume (POC, dev only) — no automation exists for these platforms yet.
            </Typography>
          </Box>
        </Stack>

        <SapFilterBar />

        <SapPlatformSummaryPanel />
      </Box>
    </SapFilterProvider>
  );
}
